import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import styled from '@emotion/styled';

import ActionButton from 'shared/components/buttons/ActionButton/ActionButton';

export const DialogButtonsWrapper = styled((props) => (
  <DialogActions classes={{ spacing: 'spacing' }} {...props} />
))`
  &.spacing {
    > :not(:first-of-type) {
      margin-left: 24px;
    }
  }
`;

const BasicDialog = ({
  open,
  handleConfirm,
  handleCancel,
  title,
  description,
  content,
  confirmText = 'Submit',
  cancelText = 'Cancel',
}) => (
  <Dialog
    open={open}
    onClose={handleCancel}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

    <DialogContent>
      {!!description && (
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
      )}
      {content}
    </DialogContent>
    <DialogButtonsWrapper>
      {handleCancel && (
        <ActionButton
          type="button"
          variant="outlined"
          color="secondary"
          onClick={handleCancel}
        >
          {cancelText}
        </ActionButton>
      )}
      {confirmText && (
        <ActionButton
          type="button"
          color="secondary"
          autoFocus
          onClick={handleConfirm}
        >
          {confirmText}
        </ActionButton>
      )}
    </DialogButtonsWrapper>
  </Dialog>
);

BasicDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  handleCancel: PropTypes.func,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  content: PropTypes.node,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
};

export default BasicDialog;
